module.exports = __webpack_public_path__ + "static/bfb-hero-5e2f79048ced504c33786d257f79673c.jpg";